import React, { useCallback, useState } from "react"
import fullscreenIcon from "./326650_fullscreen_icon.svg"
import "./style.css"

export default function FullscreenContainer({ child }) {
  const [fullscreen, setFullscreen] = useState(false)

  const onKeyboardInteraction = useCallback(event => {
    if (event.key === "Enter") {
      setFullscreen(!fullscreen);
    } else if (event.key === "Escape") {
      setFullscreen(false);
    }
  }, [fullscreen]);

  return (
    <div className={`fullscreen ${fullscreen ? "active" : ""}`}>
      <div className="buttons-container">
        <span
          tabIndex={-1}
          role="button"
          onClick={() => setFullscreen(!fullscreen)}
          onKeyUp={onKeyboardInteraction}
        >
          <img
            src={fullscreenIcon}
            alt="Toggle Full Screen"
            color="currentColor"
          />
        </span>
      </div>
      {child}
    </div>
  )
}
